import baseStore from './../generic_store';

const base = baseStore('users');

const state = {
    ...base.state,
    base_url: '/api/users',
    resourceName: 'Utilisateur',
    model: {
        email: null,
        name: null,
        password: null,
    },
};

const getters = {
    ...base.getters,
};

const actions = {
    ...base.actions,
};

const mutations = {
    ...base.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

